import {CallJs} from "../../lib/types";

type SetupParams = {
	page: string
	form_processing_message: string
}

function on_key_down()
{
	// Empty function
}

export const setup : CallJs<SetupParams> = (replace, params) => {
	window.on_key_down = on_key_down


	/** @deprecated */
	function check_illegal_chars() {}
	/** @deprecated */
	window.check_illegal_chars = check_illegal_chars

	function change_parent_directory(id_string: string, name: string, name_value: string)
	{
		const read_el = 'select_dir_read';
		const write_el = 'select_dir_write';

		const select_dir_read_ele = document.getElementById('select_dir_read');
		const select_dir_write_ele = document.getElementById('select_dir_write');
		if (select_dir_read_ele && select_dir_read_ele.style.display == 'block')
		{
			select_dir_read_ele.style.display = 'none';
			if(select_dir_write_ele)
				select_dir_write_ele.style.display = 'block';
		}
		else if (id_string == 'cancel')
		{
			if(select_dir_write_ele)
				select_dir_write_ele.style.display = 'none';
			if (select_dir_read_ele)
				select_dir_read_ele.style.display = 'block';
			return;
		}

		const original_name = name + '_id';
		const id = Array.from(document.getElementsByName(original_name)).map(e =>
			(e instanceof HTMLInputElement && e.form && e.form.name == 'my_form') ? e.value : null
		).filter(i => i !== null)[0]

		var url = params.page + '?command=get_directory_form_data&id_string=' + id_string + '&name=' + name + '&id=' + id;

		if (name_value != '')
		{
			Array.from(document.getElementsByName(name)).forEach(e => {
				if(e instanceof HTMLInputElement && e.form && e.form.name == 'my_form')
					e.value = name_value
			})
		}

		const http = new XMLHttpRequest()

		http.open("GET", url, true);
		http.onreadystatechange = function()
		{
			if (http.readyState == 4)
			{
				// Get the data from the server
				const data = http.responseText;

				if (select_dir_write_ele)select_dir_write_ele.innerHTML = data;
			}
		}
		http.send(null);
	}

	window.change_parent_directory = change_parent_directory

	function check_file_name(file_name: string) {return null}
	window.check_file_name = check_file_name

	function check_if_record_exists(element: string, id: string, parent_id: string, is_directory: boolean)
	{
		const value = Array.from(document.getElementsByName(element)).map(e =>
			(e instanceof HTMLInputElement && e.form && e.form.name == 'my_form') ? e.value : null
		).filter(i => i !== null)[0]

		const url = params.page + '?command=record_exists&parent_id=' + parent_id + '&id=' + id + '&is_directory=' + is_directory + '&value=' + value;

		const http = new XMLHttpRequest()

		http.open("GET", url, true);
		http.onreadystatechange = function()
		{
			if (http.readyState == 4)
			{
				// Get the data from the server
				const data = http.responseText;
				if (data)
				{
					alert(data);
					return false;
				}
				else
				{
					const ele =document.getElementById('my_form_buttons')
					if(ele)
						ele.innerHTML = params.form_processing_message;
					Array.from(document.getElementsByName('my_form'))
						.forEach(ele => ele instanceof HTMLFormElement && ele.submit())
				}
			}
			return undefined
		}
		http.send(null);
		return false;
	}

	window.check_if_record_exists = check_if_record_exists

	function set_checkbox(field_name: string, field_value: string)
	{
		const field = Array.from(document.getElementsByName(field_name))
		.forEach(e => {
			if(e instanceof HTMLInputElement && e.form && e.form.name == 'my_form')
			{
				if (e.value == field_value)
				{
					e.checked = true;
					return;
				}
			}
		})
	}
	window.set_checkbox = set_checkbox
}


// WEBPACK FOOTER //
// ./src/memory/component/form.ts